const mutations = {
  getDownloadBanner: (state, download_banner) => {
    state.download_banner = download_banner;
  },
};

export default mutations;
